import styled from 'styled-components';

import {$} from '~/styles/global';

export const Wrapper = styled.div`
  height: 100%;
  background: ${$.colorWhite};
  display: flex;
  flex-direction: row;
`;

export const Main = styled.div`
  flex: 1;
  overflow: auto;
`;